import {Component, ViewChild, Input, AfterViewInit} from '@angular/core';
import {IonSegment, IonTabs} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import {Api} from '../../../providers/api/api';
import {Events} from '../../../providers/events';

@Component({
  selector: 'details-tab-card',
  templateUrl: 'details-tab-card.html',
  styleUrls: ['./details-tab-card.scss']
})
export class DetailsTabCardComponent implements AfterViewInit {

  @ViewChild(IonSegment) segment: IonSegment;

  mapTabEnabled = false;
  enableQuittieren = true;
  smallDevice:boolean = ((this.api.platform.is('android') || this.api.platform.is('ios')) && !this.api.platform.is('tablet'));

  @ViewChild('detailTabs') tabRef: IonTabs;
  @ViewChild('cardContent') cardContent: any;

  @Input() set tabsRootData(patientData) {
    this.mapTabEnabled = !!patientData?.addressData.firstname;
  }

  @Input() set tabsAlertData(alertData) {
    if (alertData?.inProgress) {
      this.enableQuittieren = true;
    } else {
      this.enableQuittieren = false;
    }
  }

  @Input()
  dataType: string;

  private _initView = false;

  currentSegment = 'location';

  constructor(private events: Events, public api: Api, private translate:TranslateService) {
    this.events.subscribe('changeTabData', () => {
        if (this._initView) {
          this.currentSegment = 'location';
        }
    });
  }

  ngAfterViewInit() {
    this._initView = true;
  }

  segmentChanged($event: CustomEvent<any>) {
    this.currentSegment = $event.detail.value;
  }

  showHeader() {
    switch (this.currentSegment) {
      case 'location': return this.translate.instant('Standortdetails');
      case 'contact': return this.translate.instant('Contacts');
      case 'history': return this.translate.instant('Verlauf');
      case 'status': return this.translate.instant('Status');
      case 'gps': return this.translate.instant('GPSPosition');
      case 'notizen': return this.translate.instant('Notizen');
      case 'quittieren': return this.dataType === 'patient' ? this.translate.instant('AcknowledgeAlert') : this.translate.instant('AcknowledgeTechnicalAlert');
    }
    return '';
  }
}
